import React, { useEffect, useState } from "react";
import CustomDropdown from "../custom-dropdown";
import { convertArrayToObject } from "../../../helpers/catalog-helper";
import moment from "moment";
import { isMobileDevice } from "../../../helpers/device-info-helper";
import { COMPARE_DATES, CTA_SIZE, CTA_TYPE, DATE_TIME_FORMATS } from "../../../data/constants";
import { CUSTOM_RANGE, DATE_FIELD_ERROR } from "./constant";
import DateRangeIcon from "@mui/icons-material/DateRange";
import 'react-day-picker/dist/style.css';
import "./style.scss";
import InlineDateRangePicker from "../date-range-picker-inline";
import { Modal } from "@mui/material";
import CModal from "../Modal";

type PropsType = {
  options: any;
  drpdownUniqueKey: string;
  placeholder: string;
  preSelectedDropdownValue: any;
  getDateRange: (data: any, preSelectedValuesDetail: string[]) => void;
  customStyle?: string;
  dropdownClass?: string;
  className?: string;
  maxDaysDuration?: number;
};

const DatePickerWrapper = (props: PropsType) => {
  const {
    options,
    drpdownUniqueKey,
    preSelectedDropdownValue,
    getDateRange,
    customStyle = "h-[36px]",
    dropdownClass = "",
    placeholder,
  } = props;
  const [isRangePickerOpen, setIsRangePickerOpen] = useState(false)
  const [preSelectedValuesDetail, setPreSelectedValuesDetail] = useState(
    preSelectedDropdownValue
  );
  const [dateRange, setDateRange] = useState({
    startDate: moment(),
    endDate: moment(),
  });
  const advanceOption = convertArrayToObject(options, drpdownUniqueKey);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    if (preSelectedDropdownValue && preSelectedDropdownValue !== "") {
      handleSubmit([preSelectedDropdownValue]);
    }
  }, []);

  const handleSubmit = (selectedOption: any) => {
    if (!selectedOption[0] || selectedOption[0] === "") return;
    const getDays = advanceOption[selectedOption[0].toLowerCase()]?.totalDays;
    if (selectedOption[0] !== CUSTOM_RANGE) {
      const getStartDay = moment().subtract(getDays, "days");
      const curDateRange = {
        startDate: getStartDay,
        endDate:
          COMPARE_DATES.YESTERDAY === selectedOption[0]
            ? getStartDay
            : moment(),
      };
      setDateRange(curDateRange);
      getDateRange(
        {
          startDate: getStartDay,
          endDate:
            COMPARE_DATES.YESTERDAY === selectedOption[0] ||
            COMPARE_DATES.TODAY === selectedOption[0]
              ? getStartDay
              : curDateRange.endDate,
        },
        selectedOption
      );
    } else {
      setIsRangePickerOpen(true)
    }
    setPreSelectedValuesDetail(selectedOption[0]);
  };

  const onDateRangeSubmission = (data: any) => {
    const { startDate, endDate } = data;
    setDateRange({
      startDate: startDate,
      endDate: endDate
    })
    getDateRange({ startDate, endDate }, preSelectedValuesDetail);
    setIsRangePickerOpen(false);
  };

  const closeDateRangeSelector = () => {
    setIsRangePickerOpen(false);
    setIsDropdownOpen(true);
  }

  const getStartAndEndDate = (
    momentStart: moment.Moment,
    momentEnd: moment.Moment
  ) => {
    const format = DATE_TIME_FORMATS.dayMonthYearShort;
    if (momentEnd.diff(momentStart, "day") < 1) {
      return momentStart.format(format);
    } else {
      return `${momentStart.format(format)} - ${momentEnd.format(format)}`;
    }
  };

  return (
    <div className={"wrapperContainer relative"}>
      <div
        className={`dropdownContainer w-full min-h-36 ${
          isMobileDevice()
            ? `${customStyle} mobileCustomClass `
            : `${customStyle} desktopCustomClass `
        }`}
      >
        <CustomDropdown
          isSelectOpen={isDropdownOpen}
          setIsSelectOpen={setIsDropdownOpen}
          optionsMap={advanceOption}
          isMultiSelect={false}
          placeholder={placeholder}
          getListItemText={(data: any) => {
            return data?.value;
          }}
          getSelectedItemText={(data: any) => {
            return (
              <div className="flex items-center justify-start">
                <DateRangeIcon className="opacity-50 mr-6 ml-[-8px] h-20 w-20" />
                {getStartAndEndDate(dateRange.startDate, dateRange.endDate)}
              </div>
            );
          }}
          onSubmit={(value: any) => {
            handleSubmit(value);
          }}
          preSelectedValues={preSelectedValuesDetail}
          uniqueKey={drpdownUniqueKey}
          showErrorBox={false}
          dropdownSelectClass={`${customStyle} p-0 dropdownSelectClass min-w-[200px] sm:min-w-[140px] ${dropdownClass}`}
          parentClass={"h-0"}
        />
         {isRangePickerOpen && !isMobileDevice() && (
          <Modal
            open={isRangePickerOpen}
            onClose={closeDateRangeSelector}
            className="flex justify-center items-center"
          >
            <div className="shadow-md overflow-hidden rounded-[8px] bg-white">
              <InlineDateRangePicker
                maxDaysDuration={props?.maxDaysDuration}
                hideFooter={false}
                onBackBtnPress={closeDateRangeSelector}
                onConfirm={onDateRangeSubmission}
              />
            </div>
          </Modal>
        )}
        {isMobileDevice() && (
          <CModal
            className="overflow-scroll flex justify-center items-center"
            isOpen={isRangePickerOpen}
            handleClose={closeDateRangeSelector}
            body={
              <InlineDateRangePicker
                hideFooter={false}
                onBackBtnPress={closeDateRangeSelector}
                onConfirm={onDateRangeSubmission}
              />
            }
          >
          </CModal>
        )}
      </div>
    </div>
  );
};

export default DatePickerWrapper;
